import { useModal } from '@flecto/ui'

import { ModalAddDocument } from '../components/ModalAddDocument/ModalAddDocument'

export function useModalAddDocument() {
  return useModal(<ModalAddDocument />)
}
